module.exports = __webpack_public_path__ + "static/media/04 - Hat Open.8dc344cd.wav";